<template>
  <TsGrid :cols="4" :mobileCols="2">
    <TsColumn v-for="card in data">
      <NuxtLink :href="card.link" target="_blank">
      <TsCard
        :dataTestid="`${dataTestid}-${card.title}-card`"
        noBorder
        noShadow
        appendClass="bg-info/10 text-center"
      >
        <template #content>
          <TsImage
            :dataTestid="`${dataTestid}-${card.title}-image`"
            class="mb-2 inline"
            :src="card.image"
            alt="deal"
            width="64px"
            loading="lazy"
          />
          <TsTypography
            :dataTestid="`${dataTestid}-${card.title}-title`"
            as="p"
            align="center"
            append-class="text-primary mb-0"
            >{{ card.title }}</TsTypography
          >
        </template>
      </TsCard>
    </NuxtLink>
    </TsColumn>
  </TsGrid>
</template>

<script setup lang="ts">


const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
  data: object[];
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  data: () => [
    {
      title: "Firefox",
      image: "/images/logos_firefox.svg",
    },
    {
      title: "Chrome",
      image: "/images/logos_chrome.svg",
    },
    {
      title: "Microsoft Edge",
      image: "/images/logos_microsoft-edge.svg",
    },
    {
      title: "Safari",
      image: "/images/devicon_safari.svg",
    },
  ],
});
</script>
